import React, { useState } from "react";

import { BiChevronDown } from "react-icons/bi";

import { StyledMenu } from "../../Generic/AnchorMenu";
import { FormButtonProps } from "../Button";
import { StyledButton, StyledIconButton, Wrapper } from "./styles";

interface SplitButtonProps extends FormButtonProps {
  options?: React.ReactChild;
  buttonLoading?: boolean;
  onClickSplit?: FormButtonProps["onClick"];
}

const SplitButton: React.FC<SplitButtonProps> = (props) => {
  const { children, options, onClick, onClickSplit, loading, buttonLoading, ...rest } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <Wrapper>
      <StyledButton
       loading={buttonLoading}
        hasOptions={!!options}
        onClick={(event) => (onClick ? onClick(event) : setAnchorEl(event.currentTarget))}
      {...rest}>{children}
      </StyledButton>
      {!!options && (
        <StyledIconButton
          loading={loading}
          disabled={rest.disabled}
          customColor={rest.customColor}
        onClick={onClickSplit || ((event) => setAnchorEl(event.currentTarget))}
        >
          <BiChevronDown />
        </StyledIconButton>
      )}
      <StyledMenu
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        keepMounted
        onClose={() => setAnchorEl(null)}
        open={!!anchorEl}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        {options}
      </StyledMenu>
    </Wrapper>
  );
};

export { SplitButton };
